import { BASE_URL } from "./helpers/consts";

export function getGlobalSchema() {
  return [
    {
      "@type": "WebSite",
      "name": "ЖК Новый Фамильный",
      "url": BASE_URL,
    },
    {
      "@type": "Organization",
      "name": "Агидель Инвест Строй",
      "url": BASE_URL,
      "logo": {
        "@type": "ImageObject",
        "url": BASE_URL + 'schema/schema-logo.png',
      },
      "telephone": "+73472586611"
    }
  ];
}
